export const GET_STATUS_LEAD_ID = "GET_STATUS_LEAD_ID"
export const GET_STATUS_LEAD_ID_SUCCESS = "GET_STATUS_LEAD_ID_SUCCESS"
export const GET_STATUS_LEAD_ID_FAIL = "GET_STATUS_LEAD_ID_FAIL"

export const CREATE_STATUS_LEAD_ID = "CREATE_STATUS_LEAD_ID"
export const CREATE_STATUS_LEAD_ID_SUCCESS = "CREATE_STATUS_LEAD_ID_SUCCESS"
export const CREATE_STATUS_LEAD_ID_FAIL = "CREATE_STATUS_LEAD_ID_FAIL"